import { Alert, Snackbar, Typography, useTheme } from '@mui/material';


interface MessagesSnackbarProps {
  open: boolean;
  onClose: () => void;
  message: string;
  severity: 'success' | 'error' | 'info' | 'warning';
  duration: number | null;
  verticalPosition?: 'top' | 'bottom';
  horizontalPosition?: 'left' | 'center' | 'right';
}

const MessagesSnackbar: React.FC<MessagesSnackbarProps> = ({ open, onClose, message, severity, duration, verticalPosition = 'bottom', horizontalPosition = 'right' }) => {
  const theme = useTheme();

  return (
    <Snackbar onClose={onClose}
      anchorOrigin={{ vertical: verticalPosition, horizontal: horizontalPosition }}
      open={open}
      autoHideDuration={duration}
    >
      <Alert onClose={onClose}
        severity={severity}
        variant="outlined"
        sx={{
          width: '100%',
          backgroundColor: 'white',
          border: '1px solid',
          boxShadow: '0 1px 2px 1px #1018280D',
          borderRadius: '12px',
          borderColor: theme.palette.custom.gray[300],
        }}>
        <Typography variant='textSM'
          fontWeight={600}>
          {message}
        </Typography>
      </Alert>
    </Snackbar>
  );
};

export default MessagesSnackbar;